export const REDUCER_KEY = 'search';
export const SET_SEARCH_DATA_CLASSICAL = 'SET_SEARCH_DATA_CLASSICAL';
export const SET_SEARCH_INITIAL_STATE = 'SET_SEARCH_INITIAL_STATE';
export const SET_SEARCH_INITIAL_STATE_JAZZ = 'SET_SEARCH_INITIAL_STATE_JAZZ';
export const SET_SEARCH_DATA_JAZZ = 'SET_SEARCH_DATA_JAZZ';
